<template>
  <div class="background" :class="{'longCont1':long}">
    <div class="chart-container" :class="{'longCont':long}">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('dayBydayRe')}}</p>
          <p style="font-size: 9px;">{{$t('period')}}: {{staTime}}-{{endTime}}</p>
        </div>
      </div>
      <table class="status-table1" :class="{'zh11':!isEn,'de1':isDe||isIt||isFr}">
        <tr>
          <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
          <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
        </tr>
        <tr>
          <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
          <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
        </tr>
        <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
        <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{pump_device}}</td></tr>
        <tr>
          <td class="td1 td4">{{$t('disType')}}</td><td colspan="4" class="td4">{{statics.medical_history}}</td>
          <td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>
        </tr>
      </table>
      <div class="small-hr"></div>
      <!-- <div element-loading-text="Loading" v-loading.fullscreen.lock="loading" > -->

        <div v-for="(base, p) in pagePos">

          <div v-if="p==1">
            <div style="clear: both"></div>
            <div class="page-seperator"></div>

            <div class="page-starter">
              <!--<br/><br/><br/><br/>-->
            </div>
          </div>

          <div class="chart-item2" v-for="(day,index) in date.slice(base, base+perPage[p])":class="{'spe-item2':((base+index)%3!==0),'fr2':isFr}">
              <div class="date date-spe3"> <span >{{day}}</span></div>
              <div class="eat-label eat-spe3" :class="{'zh1':!isEn,'de11':isDe,'po1':isPo||isFr}">
                <span class="eat-label-spe1" :class="{'zh2':!isEn,'de2':isDe,'po2':isPo||isFr}" >{{$t('Breakfast')}}</span>
                <span :class="{'zh3':!isEn,'de3':isDe,'po3':isPo||isFr}">{{$t('Lunch')}}</span>
                <span  :class="{'zh4':!isEn}">{{$t('Dinner')}}</span>
              </div>
              <div :id="'sgChart'+(base+index)" class="graph" :element-loading-text="loadingText"  v-loading="index===1?loading:false" style="margin-top: 35px;"></div>
              <div class="carb carb-spe2">
                <span>{{$t('carbs')}}(g)</span>
                <div :id="'carb'+(base+index)">
                  <label v-for="i in carb[base+index]">{{i[1]}}</label>
                  <img class="breakfast" v-for="b in autoBreakfast[base+index]" src="/static/legend/automode/早餐.png"/>
                  <img class="lunch" v-for="b in autoLunch[base+index]" src="/static/legend/automode/中餐.png"/>
                  <img class="dinner" v-for="b in autoDinner[base+index]" src="/static/legend/automode/晚餐.png"/>
                  <img class="snack" v-for="b in autoSnack[base+index]" src="/static/legend/automode/零食.png"/>
                </div>
              </div>
              <div :id="'baChart'+(base+index)" class="graph bolus" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
          </div>
        </div>

        <div v-if="chartEndPage.show">
          <div style="clear: both"></div>
          <div class="page-seperator"></div>
          <div class="page-starter">
            <!--<br/><br/><br/><br/>-->
          </div>
        </div>

        <hr class="small-hr">
        <div class="legend-group" :class="{'zh5':!isEn,'it5':isIt,'po5':isPo,'du5':isDu||isFr||isCz}">
          <div class="legend"><img src="../../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/hypo.png" class="img-spe"><span>{{$t('hypo')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/calib.png"><span>{{$t('calib')}}</span></div>
          <div class="legend "><img src="../../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
          <div class="legend legend-spe1"><img src="../../assets/Hcp-icon/legend/warm up.png"><span>{{$t('warm')}}</span></div>
          <div class="legend legend-spe1" :class="{'zh6':!isEn}"><img src="../../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
          <div class="legend legend-spe1" :class="{'zh7':!isEn}"><img src="../../assets/Hcp-icon/legend/temp basal.png"><span>{{$t('tampBasal')}}</span></div>
          <div class="legend legend-spe3" :class="{'zh8':!isEn}"><img src="../../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
          <div class="legend legend-spe4" :class="{'zh9':!isEn}"><img src="../../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
          <div class="legend legend-spe5" :class="{'zh10':!isEn}"><img src="../../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
          <div class="legend legend-spe1" :class="{'zh11':!isEn}"><img src="../../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>
          <div class="legend legend-spe1"><img src="../../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
          <div class="legend legend-spe6" :class="{'zh12':!isEn}"><img src="../../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
          <div class="legend legend-spe7" :class="{'zh13':!isEn}" ><img src="../../assets/Hcp-icon/legend/carbs.png"><span>{{$t('carbs')}}</span></div>
          <div class="legend legend-spe2" :class="{'zh14':!isEn}"><img src="../../assets/Hcp-icon/legend/exercise.png"><span>{{$t('exercise')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/calibrate_1.png"><span>{{$t('BG Reading')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
          <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>
        </div>

        <div class="page-end"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  import B64 from '../../auth/base64'
  import {loading} from '../mixins/loading'
  export default {
    mixins: [loading],
    data() {
      return {
        pringtPre:false,
        pump_device:'--',
        uid:0, st:0,et:0, statics:{},devices:['--','--','--'],hb1c:['--'],long:false,isDe:false,isIt:false,isPo:false,isFr:false,
        isDu:false,isCz:false,
        pagePos:[],perPage:[],
        chartEndPage:{show:false},
       //dd图表
        sg:[], basal:[],bolus:[],timeSection:[],staTime:'',endTime:'',isEn:false,isMg:'',ts:[],trans:[],
        mealTime1:[[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10]],
        mealTime2:[[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10]],
        mealTime3:[[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10]], NewBasal:[],
        sensor_alarm:[], pump_alarm:[],carb:[],exercise:[],calib:[],bg:[],basalMax:5,bolusMax:5,
        extend_bolus:[[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10]],
        basal_suspend:[],stopBasal:[],manualStop:[],tempBasal:[],
        sgChart0:null, sgChart1:null, sgChart2:null, sgChart3:null, sgChart4:null,
        sgChart5:null, sgChart6:null, sgChart7:null, sgChart8:null, sgChart9:null,
        sgChart10:null, sgChart11:null, sgChart12:null,sgChart13:null,
        baChart0:null, baChart1:null, baChart2:null, baChart3:null, baChart4:null,
        baChart5:null, baChart6:null, baChart7:null, baChart8:null, baChart9:null,
        baChart10:null, baChart11:null, baChart12:null,baChart13:null,
        chart2:null,dayNum:7,
        autoModeBasal:[],
        autoModeCorrBolus:[],
        autoBreakfast:[],
        autoLunch:[],
        autoDinner:[],
        autoSnack:[],
        sgMax:20,titleText:'',
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        pickerOptions2:{
          disabledDate(time){
            let flag1 = time.getTime()>Date.now(),flag2=true;
            return flag1;
          }
        },
        date:[],
        textStyle:{
          color:'#282828',
          fontWeight:'normal',
          fontSize:'12',
          fontFamily:'SFUIText-Regular'
        },
        titlePadding:[12,0,0,35],
        grid2:{x:'10%',y:'5%',width:'83%',height:'60%'},
        yAxisLabel:{interval:0,margin:5,textStyle:{color:'#282828',baseline:'middle',},showMinLabel:false},
        yAxisLabel2:{show:false},
      }
    },
    computed: {
      DataD(){
        return this.$store.state.DataD;
      },
      DataSG(){
        return this.$store.state.DataSG;
      },
      DataBasal(){
        return this.$store.state.DataBasal;
      },
      DataBolus(){
        return this.$store.state.DataBolus;
      },
    },
    methods: {
      drawSgChart(id,i) {
        let that =this;
        this[id] = echarts.init(document.getElementById(id));
        this.registLoading(id,this[id])
        this[id].setOption({
          title:{
            text:this.titleText,
            textStyle:this.textStyle,
            padding:this.titlePadding,
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[i][0]*1000),
            max:new Date(this.timeSection[i][1]*1000),
            axisLabel: {show:false},
            axisLine: {lineStyle: {color: '#ccc'}},
            interval:3600*3000,
          }],
          yAxis: [{
            type:'value',
            min:0,
            max:this.sgMax,
            axisLabel:this.yAxisLabel,
            axisLine:{lineStyle:{color:'#ccc'}},
            boundaryGap:false,
            splitLine:{show:true,},
            axisTick:{length:0},
          }],
          grid:this.grid2,
          animation:false,
          series: [
            {
              type: 'scatter',
              data: this.sg[i],
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.DataD.target_low*18:this.DataD.target_low}, {yAxis:(this.isMg)?this.DataD.target_high*18:this.DataD.target_high}]
                ],
                tooltip:{show:false,},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.DataD.hypo*18:this.DataD.hypo}],
                symbol:['circle','circle'],
                symbolSize: 1,
                silent:true,
                lineStyle: {normal: {color: 'rgba(255,0,0,0.5)', type: 'solid',}},
                label:{normal:{show:false}},
              },
              itemStyle: {normal: {
                color:function (params) {
                  let color = '#2cd200';
                  if(params.value[1]<0.1&&params.value[2]==='H'){
                    color = '#666';
                  } else{
                    if(that.isMg){
                      if(params.value[1]>that.DataD.target_high*18){color = '#e6be00'}
                      if(params.value[1]<that.DataD.target_low*18){color = '#ff5c5c'}
                    }else{
                      if(params.value[1]>that.DataD.target_high){color = '#e6be00'}
                      if(params.value[1]<that.DataD.target_low){color = '#ff5c5c'}
                    }
                  }
                  let type = params.value[2];
                  if((type==='NC'&&params.value[1]===0)||type==='DE'||type==='CE0'||type==='CE1'){
                    color = 'transparent';
                  }
                  return color;
                }
              }},
              symbolSize:2,
            },
            {
              type: 'scatter',
              data: this.trans[i],
              symbol:'rect',
              symbolSize:5,
              itemStyle: {normal: {color: '#00a107'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'New Sensor';
                },
              },
            },
            {
              type: 'scatter',
              data: this.calib[i],
              symbol:'image://static/legend/calib.png',
            },
            {
              type: 'scatter',
              data: this.bg[i],
              symbol:'image://static/legend/calibrate_1.png',
            },
            {
              type: 'custom',
              data:this.mealTime1,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: 'rgba(170,170,170,0.15)'}},
            },
            {
              type: 'custom',
              data:this.mealTime2,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: 'rgba(170,170,170,0.15)'}},
            },
            {
              type: 'custom',
              data:this.mealTime3,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: 'rgba(170,170,170,0.15)'}},
            },
          ]
        },false,true);
      },
      drawBasalChart(id,i) {
        let that=this;
        this[id] = echarts.init(document.getElementById(id));
        this[id].setOption({
          title:[
            {
              text: this.$t('basal')+' '+this.$t('basal_unit'),
              textStyle:this.textStyle,
              padding:this.titlePadding,
            },{
              text: this.$t('bolus')+' '+this.$t('ins_unit'),
              textStyle: this.textStyle,
              right: '17',
              top:'7',
            },
          ],
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[i][0]*1000),
            max:new Date(this.timeSection[i][1]*1000),
            // axisLabel:{interval:0,margin:12,textStyle:{color:'#282828',baseline:'middle'},
            //   formatter: function(value,index){
            //     let H = new Date(value).getHours();
            //     if(index%8===0&&index!==0){
            //       H = H+24+':00';
            //       return  H;
            //     } else {
            //       if(index%2===0){
            //         H = H<10 ? ('0'+H+':00' ): H+':00';
            //         return  H;
            //       }else{
            //         return ' ';
            //       }
            //     }
            //   },
            // },
            splitNumber: 8,
            axisLabel:{
              showMaxLabel:true,
              interval:0,margin:12,textStyle:{color:'#282828',baseline:'middle'},
              formatter: function(value,index){
                // let H = new Date(value).getHours();
                index=(value-that.timeSection[i][0]*1000)/(3600000*3);   //
                let H=index*3;

                if(H<24){
                  if(H%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  // console.log('time axis 24H');
                  return '24:00';
                }
              },
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            // interval:3600*3000,
          }],
          yAxis: [
            {
              type:'value',
              boundaryGap:false,
              min:0,
              max:this.basalMax,
              splitLine:{show:true,},
              axisTick:{length:0},
              axisLabel:this.yAxisLabel,
              axisLine:{lineStyle:{color:'#ccc'}},
            }, {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
              axisLabel:this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
            }
          ],
          grid:this.grid2,
          animation:false,
          series: [
            {
              type: 'line',
              data:this.basal[i],
              // step:'middle',
              itemStyle: {normal: {color: '#00ff40'}},
              symbolSize:2,
            },
            {
              type: 'line',
              data:this.basal_suspend[i],
              itemStyle: {normal: {color: '#ff0000'}},
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              data:this.tempBasal[i],
              itemStyle: {normal: {color:  '#00ff40'}},
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              data:this.manualStop[i],
              itemStyle: {normal: {color: '#ff0000'}},
              symbolSize:1,
            },
            {
              type: 'scatter',
              data:this.stopBasal[i],
              symbol:'image://static/legend/patch Deactivated.png',
              symbolSize:8,
            },
            {
              type: 'scatter',
              data:this.NewBasal[i],
              symbol:'image://static/legend/new Patch.png',
              symbolSize:10,
            },
            {
              type: 'bar',
              data:this.bolus[i],
              yAxisIndex:1,
              itemStyle: {normal: {color: '#182f82'}},
              barWidth:'4',
            },
            {
              type: 'custom',
              data:this.extend_bolus[i],
              yAxisIndex:1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              itemStyle:{normal: {color: '#ffe3ef'},emphasis:{color: '#f00'}},
            },
            {
              type: 'custom',
              name:this.$t('t1222_autoModeBasal'),
              data:this.autoModeBasal[i],
              yAxisIndex:0,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              // tooltip:{backgroundColor:'#333',
              //   formatter:function(params){
              //     // let date = params.value[0];
              //     // let time = format.formatterDate5(date);
              //     // //return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
              //     // //return '0.23'
              //
              //     let date = params.value[0];
              //     let time = format.formatterDate5(date);
              //     return  time[0]+':'+time[1]+', '+'TempBasal: '+params.value[1];
              //   },
              // },
              itemStyle:{normal: {color: '#00ff4c'},emphasis:{color: '#00ff5c'}},
            },

            {
              type: 'bar',
              name:this.$t('t1222_autoModeCorrBolus'),
              data:this.autoModeCorrBolus[i],
              yAxisIndex:1,
              itemStyle: {normal: {color: '#182f82'}},
              // tooltip:{backgroundColor:'#333',
              //   formatter:function(params){
              //     console.log('params:', params);
              //     // let date = params.value[0];
              //     // let time = format.formatterDate5(date);
              //     // return time[0]+':'+time[1]+', '+params.value[2]+': '+params.value[1]+ins_unit2;
              //   },
              // },
              barWidth:'4',
            },
          ]
        },false,true);
      },
      drawCharts2(){
        let that =this;
        this.date.map(function (e,i) {
          let id1 ='sgChart'+i;
          let id2 ='baChart'+i;
          that.drawSgChart(id1,i);
          that.drawBasalChart(id2,i);
        });
        let timer = setTimeout(this.makeCarb,1000)
      },
      chartsDispose2(){
        let dayNum = parseInt(sessionStorage.getItem('dayNum'));
        for(let i=0;i<dayNum;i++){
          let id1 ='sgChart'+i;
          let id2 ='baChart'+i;
          this[id1].dispose();
          this[id2].dispose();
        }
        sessionStorage.setItem('dayNum',this.dayNum);
      },
      makeCarb(){
        let carbs = this.carb;
        let time = this.timeSection;
        for(let i=0;i<carbs.length;i++){
          if(carbs[i].length>0){
            for(let j =0;j<carbs[i].length;j++){
              let t1 = 0;
              let w =0;
              t1 =carbs[i][j][0]-time[i][0];
              w = (t1/864).toFixed(1)+'%';
              let id = 'carb'+i;
              const OBJ = document.getElementById(id);
              const label= OBJ.getElementsByTagName('label');
              label[j].style.zIndex = 100+i+j;
              label[j].style.left = w;
            }
          }
        }

        // 自动模式早餐
        let className=['breakfast', 'lunch', 'dinner', 'snack'];
        let autoMeal=[this.autoBreakfast, this.autoLunch, this.autoDinner, this.autoSnack];

        for(let i=0; i<className.length; i++) {

          for (let d=0; d<autoMeal[i].length; d++) {
            for (let j=0; j<autoMeal[i][d].length; j++) {
              let t1 = 0;
              let w =0;
              t1 =autoMeal[i][d][j][0]-time[d][0];
              w = (t1/864).toFixed(1)+'%';
              let id = 'carb'+d;
              const OBJ = document.getElementById(id);
              const label= OBJ.getElementsByClassName(className[i])
              console.log('autoMeal:', OBJ, label, className[i])
              this.pringtPre =true
              label[j].style.zIndex = 100+d+j;
              label[j].style.left = w;
            }
          }
        }

      },
      getDate(){
        for(let i=0;i<this.dayNum;i++){
          let day = this.st+i*86400;
          let time =(this.isEn)?format.formatterDate4(day):format.formatterDate3(day);
          let weeks =  format.formatterDay(this,day);
          this.date[i] =time+' '+weeks;
        }
        this.staTime = format.formatterDate2(this.st);
        this.endTime = format.formatterDate2(this.et);
      },
      getDdReportInfo(report_data) {
        let data =  report_data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        if ('EasyPatch'==this.devices[0]) {
          document.getElementById('reportPdmTitle').innerHTML='APP';
        }
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
      },
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/dd',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      openFullScreen(){
        this.loading = true;
        setTimeout(()=>{
          this.loading = false;
        },4000);
      },
      printPdf(){
        if(this.pringtPre === false)
        {
          this.$message({
            type: 'info',
            message: '数据加载中，请稍候再打印'
          });
        }else{
          auth.print_page();
        }
      },
    },
    mounted: function () {
      self.document.title = this.$t('dayBydayRe');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.grid2.height = (lang==='fr')?'55%':'60%';
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.titleText = (this.isMg)?this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)';
      this.sgMax = (this.isMg)? 400:25;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      // this.openFullScreen();
      this.st = parseInt(sessionStorage.getItem('qst2'));
      this.et= parseInt(sessionStorage.getItem('qet2'));
      this.dayNum = parseInt((this.et-this.st)/86400)+1;
      if(this.dayNum>9){
          this.long=true;
      }
      //
      let page_index=0;
      let PER_PAGE1=9;
      let PER_PAGE2=9;
      //let PER_PAGE=100;   // equivalent to previous
      while (page_index < this.dayNum) {
        //let page_date=whichDate.slice(page_index, page_index+PER_PAGE);
        //whichDatePage.push(page_date, page_index)
        this.pagePos.push(page_index);
        if (1==this.pagePos.length) {
          page_index += PER_PAGE1;
          this.perPage.push(PER_PAGE1);
        } else {
          page_index += PER_PAGE2;
          this.perPage.push(PER_PAGE2);
        }
      }
      let chartNum=this.dayNum;
      if (chartNum>6 && chartNum<=9) {
        this.chartEndPage.show=true;
      }
      console.log('pagePos:', this.pagePos, chartNum, this.chartEndPage.show);
      //
      this.ts = auth.getTs(this.st,this.et);
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        gu:(this.isEn)?'mg/dL':'mmol/L',
      };
      param = B64.base64encode(JSON.stringify(param));
      //this.getStatics(param);
      auth.getDd(this,this.uid,param);
      this.getDate();

      let first = parseInt(sessionStorage.getItem('qFirst2'));
      if(first===1){
        auth.checkPrint(this,3,2);
      }
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 3mm;
    width: 100%;
    *height:600mm;
    min-height:330mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *height: 600mm;
    min-height:330mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .longCont1{
    *height: 604mm;
    *height: 594mm;
  }
  .longCont{
    *height: 594mm;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }
  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh11 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    background:#e6e8ea;
    width:94%;
    height:1px;
    margin:10px auto 20px;
    border-top:1px solid #3b3b3b;
  }

  .chart-item2 {
    width: 33%;
    float: left;
  }
  .chart-container .graph{
    width:100%;
    height:160px;
    margin-top:-15px;
  }

  /* .chart-container .graph.bolus{
    height:125px;
  }

  .fr2 .graph{
    margin-top:-25px;
  } */
  .date{
    width:33%;
    float:left;
    font-size:16px;
    color:#0082d2;
    letter-spacing:-0.39px;
    line-height:13px;
    text-align:center;
  }
  .date-spe3{
    width:80%;
    margin-left: 9%;
  }
  .img{
    width:100%;
    height:130px;
  }
  .eat-label{
    font-size:12px;
    color:#282828;
    letter-spacing:-0.29px;
    width:33%;
    margin:8px 0 -2px 0;
    text-align:center;
    float: left;
  }
  .eat-spe3{
    width:70%;
    margin-left: 24%;
  }
  .eat-label span{
    margin-right:8%;
  }
  .zh1{
    margin-left: 18%;
  }
  .zh1 .zh2{
    margin-right: 15%;
  }
  .zh1 .zh3{
    margin-right: 15%;
  }
  .zh1 .zh4{
    margin-right: 0;
  }
  .de11{
    width: 90%;
    margin-left: 14%;
  }
  .de11 .de2{
    margin-right: 3%;
  }
  .de11 .de3{
    margin-right: 2%;
  }
  .po1{
    width: 90%;
    margin-left: 4%;
  }
  .po1 .po2{
    margin-right: 3%;
  }
  .po1 .po3{
    margin-right: 2%;
  }
  .carb{
    width:93.4%;
    margin:2px 0 14px 3%;
    height:20px;
    line-height: 20px;
    padding-left: 5px;
    border: 1px solid #ccc;
    position: relative;
  }
  .carb span{
    float: left;
  }
  .carb label{
    display: inline-block;
    border:1px solid #00ff4c;
    border-radius:4px;
    width:27px;
    height:15px;
    line-height: 15px;
    float: left;
    position: absolute;
    font-size:14px;
    color:#000;
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 2px;
    background-color: #00ff4c;
  }
  .carb-spe2{
    width:81%;
    margin:-56px 0 14px 8%;
  }

  .page-seperator {
    *height:5cm;
    *height:20mm;
    page-break-after: always;
  }

  .page-starter {
    height:10mm;
  }

  .page-end {
    clear:both;
    height:10mm;
  }

  .legend-group{
    width:96%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:60px;
    height:20px;
    line-height: 20px;
  }
  .zh5 .legend{
    margin-right:70px;
  }
  .legend img{
    margin-right: 8px;
  }
  .legend-spe1{
    margin-right: 38px;
  }
  .legend-spe2{
    margin-bottom: 1px;
  }
  .legend-spe3{
    margin-right: 18px;
  }
  .legend-spe4{
    margin-right: 53px;
  }
  .legend-spe5{
    margin-right: 15px;
  }
  .legend-spe6{
    margin-right: 30px;
  }
  .legend-spe7{
    margin-right: 83px;
  }
  .legend-group .span1{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .img-spe{
    margin-bottom: 4px;
  }
  .zh5 .zh6{
    margin-right: 45px;
  }
  .zh5 .zh7{
    margin-right: 60px;
  }
  .zh5 .zh8{
    margin-right: 33px;
  }
  .zh5 .zh9{
    margin-right: 48px;
  }
  .zh5 .zh10{
    margin-right: 30px;
  }
  .zh5 .zh11{
    margin-right: 56px;
  }
  .zh5 .zh12{
    margin-right: 56px;
  }
  .zh5 .zh13{
    margin-right: 114px;
  }
  .zh5 .zh14{
    margin-right: 88px;
  }

  .it5 .legend{
    margin-right:40px;
  }

  .po5 .legend{
    margin-right:40px;
  }
  .du5 .legend{
    margin-right:40px;
  }
</style>



// WEBPACK FOOTER //
// quickPrint2.vue?14985f46